import React, { useState, useRef, useEffect } from "react";
import { FaHeart } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import tshirtbanner from "../Assets/tshirtbanner.png";

const products = [
  { id: 1, name: "Plain Corporate T Shirt", category: "T-Shirts", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxAJnOV3G-zjjXSTOpc7r3gZrD5dmx9fqJCg&s" },
  { id: 2, name: "Corporate T Shirts", category: "T-Shirts", image: "https://plus.unsplash.com/premium_photo-1683140435505-afb6f1738d11?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8c2hpcnR8ZW58MHx8MHx8fDA%3D" },
  { id: 3, name: " Collar T Shirt", category: "Shirts", image: "https://assets.myntassets.com/dpr_1.5,q_30,w_400,c_limit,fl_progressive/assets/images/28219632/2024/3/12/2f53aaab-40e1-4c5b-8148-6ad150e5f4341710256687634CampusSutraMenClassicOpaqueCheckedCasualShirt2.jpg" },
  { id: 4, name: "Grey Round T Shirt", category: "Shirts", image: "https://assets.myntassets.com/dpr_1.5,q_30,w_400,c_limit,fl_progressive/assets/images/15557590/2022/2/18/a88d594a-0184-4042-baad-01c2d7874cec1645166286136-Roadster-Men-Shirts-4091645166285596-1.jpg" },
  { id: 5, name: "Plain Round T Shirt", category: "T-Shirts", image: "https://d1pdzcnm6xgxlz.cloudfront.net/tops/8905875459040-18.jpg" },
  { id: 6, name: "Mens Round T Shirt", category: "T-Shirts", image: "https://img.freepik.com/free-vector/flat-minimalist-support-small-business-t-shirt_742173-10802.jpg" },
  { id: 7, name: "Mens Cotton Hoodies", category: "Hoodies", image: "https://i.pinimg.com/564x/95/f5/12/95f512de3e675bd60bb4557a6b57d98c.jpg" },
  { id: 8, name: "Mens Plain Hoodies", category: "Hoodies", image: "https://images.pexels.com/photos/1656684/pexels-photo-1656684.jpeg?cs=srgb&dl=pexels-wendywei-1656684.jpg&fm=jpg" },
];

const ProductCategoryPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [sortOrder, setSortOrder] = useState("default");
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const sliderRef = useRef(null);

  const categories = ["All", "T-Shirts", "Shirts", "Hoodies"];
  let filtered = products.filter(
    (p) => activeCategory === "All" || p.category === activeCategory
  );
  if (sortOrder === "name") filtered = [...filtered].sort((a, b) => a.name.localeCompare(b.name));

  const toggleWishlist = (id) => {
    setWishlist((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1 } },
    ],
  };

  // Fix for small screen clumping
  useEffect(() => {
    const handleResize = () => {
      sliderRef.current && sliderRef.current.slickGoTo(0, true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-[#f6ae1b] relative">
      <div className="container mx-auto px-4 py-10">

        {/* Banner Section */}
        <div className="rounded-lg shadow-xl p-6 mb-10 flex flex-col md:flex-row items-center gap-6 md:mt-32">
          <img
            src={tshirtbanner}
            alt="Category Overview"
            className="w-full md:w-1/2 rounded-lg object-cover"
          />
          <div className="md:w-1/2 text-center md:text-left">
            <h2 className="text-2xl md:text-5xl font-bold text-[#311c0e] mb-4">
              Discover Our Collection
            </h2>
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
              Discover our soft, eco-friendly hoodies crafted for all-day
              comfort. Whether you're lounging or on the go, our carefully
              designed apparel keeps you stylish and cozy while being kind to
              the planet.
            </p>
          </div>
        </div>

        {/* Filters Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">

          {/* Category Buttons */}
          <div className="flex flex-wrap gap-2 sm:gap-3 justify-center w-full md:w-auto">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full border border-[#311c0e] transition
                  ${activeCategory === cat
                    ? "bg-[#311c0e] text-white"
                    : "bg-white text-[#311c0e] hover:bg-[#311c0e] hover:text-white"} 
                  w-full sm:w-auto text-sm sm:text-base`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Sort & Size Guide */}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 w-full md:w-auto">
            <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-center">
              <label className="font-medium text-[#311c0e] text-sm sm:text-base">Sort by:</label>
              <select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                className="border border-[#311c0e] rounded px-2 py-1 w-full sm:w-auto focus:outline-none text-sm sm:text-base"
              >
                <option value="default">Default</option>
                <option value="name">Name (A–Z)</option>
              </select>
            </div>

            <button
              onClick={() => setShowSizeModal(true)}
              className="px-4 py-2 rounded bg-[#311c0e] text-white hover:bg-[#4a2a14] transition w-full sm:w-auto text-sm sm:text-base"
            >
              Size &amp; Fit Guide
            </button>
          </div>
        </div>

        {/* Products Grid */}
        {filtered.length === 0 ? (
          <p className="text-center text-gray-700 text-lg">
            No products available in this category.
          </p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
            {filtered.map((product) => (
              <div
                key={product.id}
                className="relative border border-[#311c0e] rounded-lg shadow-md p-3 flex flex-col justify-between text-center hover:shadow-2xl transition-shadow duration-300 ease-in-out h-[300px] sm:h-[320px] md:h-[340px] lg:h-[360px]"
              >
                <button
                  onClick={() => toggleWishlist(product.id)}
                  className="absolute top-3 right-3 bg-white p-1 rounded-full shadow hover:scale-110 transition"
                >
                  <FaHeart
                    className={`text-xl ${
                      wishlist.includes(product.id)
                        ? "text-red-500"
                        : "text-gray-400"
                    }`}
                  />
                </button>

                <img
                  src={product.image}
                  alt={product.name}
                  className="h-32 sm:h-36 md:h-40 lg:h-44 w-full object-contain mb-3"
                />
                <p className="text-gray-800 font-medium text-sm sm:text-base md:text-base mb-3 px-2">
                  {product.name}
                </p>
                <button className="mx-auto lg:px-8 lg:py-3 px-3 py-1.5 border border-gray-400 rounded bg-black text-white text-sm hover:text-black sm:text-[20] hover:bg-gray-100 transition">
                  Shop Now
                </button>
              </div>
            ))}
          </div>
        )}

        {/* You May Also Like Slider */}
        <div className="mt-16">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#311c0e] mb-6 text-center">
            You May Also Like
          </h3>
          <Slider ref={sliderRef} {...sliderSettings}>
            {products.map((p) => (
              <div key={p.id} className="px-2 sm:px-3">
                <div className="bg-white rounded-lg shadow p-3 sm:p-4 text-center hover:shadow-lg transition duration-300">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-28 sm:h-32 md:h-36 lg:h-40 w-full object-contain mb-2 mx-auto"
                  />
                  <p className="text-gray-800 text-sm sm:text-base font-medium">{p.name}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Size & Fit Modal */}
        {showSizeModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div
              className="absolute inset-0 bg-black bg-opacity-50"
              onClick={() => setShowSizeModal(false)}
            ></div>
            <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-md p-6 animate-fade-in">
              <button
                onClick={() => setShowSizeModal(false)}
                className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
              >
                ✕
              </button>
              <h3 className="text-2xl font-bold text-[#311c0e] mb-4 text-center">
                Size & Fit Guide
              </h3>
              <p className="mb-4 text-gray-700 text-center">
                Our tees and hoodies have a relaxed, true-to-size fit.
                For a slimmer look, consider one size down.
              </p>
              <table className="w-full border text-sm text-center">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-2 py-1">Size</th>
                    <th className="border px-2 py-1">Chest (in)</th>
                    <th className="border px-2 py-1">Length (in)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-2 py-1">S</td>
                    <td className="border px-2 py-1">36–38</td>
                    <td className="border px-2 py-1">27</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">M</td>
                    <td className="border px-2 py-1">38–40</td>
                    <td className="border px-2 py-1">28</td>
                  </tr>
                  <tr>
                    <td className="border px-2 py-1">L</td>
                    <td className="border px-2 py-1">40–42</td>
                    <td className="border px-2 py-1">29</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default ProductCategoryPage;
